import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch';
import ToggleButtons from '@atlassian/toggle-buttons';
import ToggleButtonsOld from './ui/toggle-buttons-old';

export default componentWithCondition(isVisualRefreshEnabled, ToggleButtons, ToggleButtonsOld);
